/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2024-02-14 00:00:00
 *
 *******************************************************/
import { showSABToast } from 'src/integrations/shopify-app-bridge/toast';
import { getFullAppUrlThemeEditor, getFullAppUrlThemeCodeEditor } from 'src/helpers';

/**
 * Go to App Embed of specific theme
 * @param {*} selectedThemeId
 * @param {*} isAutoEnable
 */
export const navigateToShopifyCustomizeSSR = (
  selectedThemeId,
  isAutoEnable = true,
  overwriteAppPath
) => {
  const appId = process.env.REACT_APP_SHOPIFY_INTEGRATION_SSR_APP_ID;
  const appPath = overwriteAppPath || process.env.REACT_APP_SHOPIFY_INTEGRATION_SSR_APP_PATH;

  const previewUrl = getFullAppUrlThemeEditor(
    selectedThemeId,
    isAutoEnable ? `?context=apps&activateAppId=${appId}/${appPath}` : '?context=apps'
  );

  window.open(previewUrl, '_blank');
};

/**
 * Go to App Block of specific theme
 * @param {*} selectedThemeId
 * @param {*} previewPath
 * @param {*} block
 * @param {*} template
 */
export const navigateToAppBlockSSR = (
  selectedThemeId,
  previewPath = '',
  block = '',
  template = '',
  isAutoAdd = true
) => {
  const appId = process.env.REACT_APP_SHOPIFY_INTEGRATION_SSR_APP_ID;
  const previewUrl = getFullAppUrlThemeEditor(
    selectedThemeId,
    `${template ? `?template=${template}` : ''}${previewPath ? `&previewPath=${previewPath}` : ''}${isAutoAdd ? `&addAppBlockId=${appId}/${block}&target=mainSection` : ''
    }`
  );

  window.open(previewUrl, '_blank');
};

/**
 * Navigate to theme code editor
 * @param {*} selectedThemeId
 */
export const navigateToThemeCodeEditor = (selectedThemeId: string) => {
  const url = getFullAppUrlThemeCodeEditor(selectedThemeId);

  window.open(url, '_blank');
};

/**
 * Copy text to clipboard
 * @param {*} i18n
 * @param {*} copyText
 * @param {*} customToast
 */
export const copyClipBoard = (i18n, copyText: string, toastMessage: string) => {
  try {
    const inputText = document.createElement('textarea');
    inputText.value = copyText;
    document.body.appendChild(inputText);
    inputText.select();
    inputText.focus();

    document.execCommand('copy');
    document.body.removeChild(inputText);
    if (toastMessage) {
      showSABToast(toastMessage, false);
    }
    else {
      showSABToast(i18n.translate('AdminHTML.Common.Action.copied', { t: copyText }), false);
    }
  } catch (error) {
    console.log(error);
  }
};


/**
 * Copy text to clipboard usging navigator
 * @param {*} i18n
 * @param {*} copyText
 */
export const copyClipBoardNavigator = async (i18n, copyText: string, toastMessage: string) => {
  try {
    await navigator.clipboard.writeText(copyText)
    if (toastMessage) {
      showSABToast(toastMessage, false);
    }
  } catch (error) {
    console.log(error);
  }
};
